/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/025-clubs': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12.294 6.137c-.922 0-1.751.384-2.341 1.011-.25.265-.684.58-1.153.856.22-.842.917-1.902 1.4-2.367a3.27 3.27 0 001-2.367C11.2 1.475 9.771.018 8-.001 6.229.018 4.8 1.474 4.8 3.27c0 .932.38 1.771 1 2.367.484.465 1.18 1.525 1.4 2.367-.469-.277-.903-.591-1.153-.856a3.197 3.197 0 00-2.341-1.011C1.919 6.137.47 7.6.47 9.408s1.448 3.271 3.236 3.271c.923 0 1.751-.396 2.341-1.023.263-.279.726-.627 1.223-.916-.047 2.308-1.149 4.003-2.271 4.67V16h6v-.59c-1.122-.668-2.224-2.363-2.271-4.67.498.289.961.637 1.223.916a3.21 3.21 0 002.341 1.023c1.787 0 3.236-1.464 3.236-3.271s-1.448-3.271-3.236-3.271z"/>'
  }
})
